import { Text, Stack, TextLinkButton } from 'braid-design-system';
import React from 'react';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import LayoutBox from 'src/components/LayoutBox/LayoutBox';

import Tile from './components/Tile/Tile';

export interface ToolProps {
  enabled: boolean;
  svg: string;
  label: string;
  description: string;
  destination: string;
  htag: string;
}

const Tool = ({
  enabled,
  svg,
  label,
  description,
  destination,
  htag,
}: ToolProps) => (
  <Tile enabled={enabled} destination={destination} htag={htag}>
    <Stack space="gutter">
      <LayoutBox alignment="centre">
        <CustomSvg
          svg={svg}
          height={130}
          width={150}
          testId="dashboard-tool-tile-image"
        />
      </LayoutBox>
      <Text size="large" align="center" weight="strong">
        {enabled ? <TextLinkButton>{label}</TextLinkButton> : label}
      </Text>
      <Text align="center">{description}</Text>
    </Stack>
  </Tile>
);

export default Tool;
